import { render, staticRenderFns } from "./MypageEcSiteConnectButtonParts.vue?vue&type=template&id=28c48f22&scoped=true"
import script from "./MypageEcSiteConnectButtonParts.vue?vue&type=script&lang=ts"
export * from "./MypageEcSiteConnectButtonParts.vue?vue&type=script&lang=ts"
import style0 from "./MypageEcSiteConnectButtonParts.vue?vue&type=style&index=0&id=28c48f22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c48f22",
  null
  
)

export default component.exports